import { Link } from 'react-router-dom';
import type { SpecialItem } from '@/types/content';

interface SpecialCardProps {
  item: SpecialItem;
  height?: string;
}

export default function SpecialCard({ item, height = 'h-56 md:h-64' }: SpecialCardProps) {
  return (
    <Link
      to={`/special/${item.id}`}
      className={`group relative block w-full ${height} rounded-lg overflow-hidden border border-background-200 hover:border-primary-500/60 transition-colors cursor-pointer`}
    >
      <img
        src={item.cover}
        alt={item.title}
        title={`${item.title} - 91.con 热点专题`}
        className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-background-50/10" />
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium mb-2.5">
          <i className="ri-fire-line" />热点专题
        </span>
        <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-400 transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">{item.intro}</p>
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-article-line" />
            {item.newsIds.length} 篇资讯
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-play-list-line" />
            {item.videoIds.length} 个视频
          </span>
        </div>
      </div>
    </Link>
  );
}